import { Behavior } from "../../base/Behavior";
import { PanelProps } from "../../components/panel/PanelProps";
import { OverlayProps } from "../OverlayProps";
import { BehaviorTypes } from "../../base/BehaviorTypes";
import { ButtonProps } from "../../components/button/ButtonProps";
import { Image } from "../../components/image/Image";
import { Panel } from "../../components/panel/Panel";

export class ImageViewerBehavior extends Behavior {
    private static _behaviors: ImageViewerBehavior;

    public static get behaviors(): ImageViewerBehavior {
        this._behaviors ??= BehaviorTypes.get("ImageViewer");
        return this._behaviors;
    }

    override get type(): string {
        return "ImageViewer";
    }

    get addlHeaderProps(): Partial<PanelProps> {
        return {};
    }

    get defaultOverlayProps(): Partial<OverlayProps> {
        return {
            style: {
                width: "94%",
                height: "94%",
                position: "absolute",
                left: "3%",
                top: "3%",
                backgroundColor: "#eee",
                borderRadius: "4px"
            },
            coverPageHeader: false
        }
    }

    get addlCloseButtonProps(): Partial<ButtonProps> {
        return {};
    }

    get closeButtonLocation(): 'left' | 'right' {
        return 'right';
    }

    get allowEmailDefault(): boolean {
        return true;
    }

    get allowDownloadsDefault(): boolean {
        return true;
    }

    get showOpenInButtonsDefault(): boolean {
        return true;
    }

    get displayZoomControlsDefault(): boolean {
        return true;
    }

    public syncZoomControls(image: Image, controlsPanel: Panel) {
        controlsPanel.removeAll();
        const newControls = image?.zoomControls;
        if (newControls) {
            controlsPanel.add(newControls);
        }
    }
}

ImageViewerBehavior.register();
